import { Box, IconButton } from "@mui/material"
import { MoreVertOutlined } from "@mui-symbols-material/w300"
import type { CellContext } from "@tanstack/react-table"
import type { ReactElement } from "react"
import { useRef, useState } from "react"

import WarehouseShelvingFormDialog from "../WarehouseShelvingForm/WarehouseShelvingFormDialog"

import WarehouseShelvingRowDropdownMenu from "./WarehouseShelvingRowDropdownMenu"

import type { WarehouseShelving } from "@/graphql/codegen/graphql"

interface WarehouseShelvingItemActionsProps {
  row: CellContext<WarehouseShelving, unknown>["row"]
  onRefresh: () => void
}

const WarehouseShelvingRowActions = ({ row, onRefresh }: WarehouseShelvingItemActionsProps): ReactElement => {
  const anchorElRef = useRef<HTMLButtonElement>(null)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [isFormDialogOpen, setIsFormDialogOpen] = useState(false)

  const handleDropdownOpen = () => {
    setIsDropdownOpen(true)
  }
  const handleDropdownClose = () => {
    setIsDropdownOpen(false)
  }

  const handleFormDialogOpen = () => {
    setIsDropdownOpen(false)
    setIsFormDialogOpen(true)
  }

  const handleFormDialogSubmit = () => {
    setIsFormDialogOpen(false)
    onRefresh()
  }

  const handleFormDialogClose = () => {
    setIsFormDialogOpen(false)
  }

  return (
    <Box className='flex items-center justify-center' ref={anchorElRef}>
      <IconButton onClick={handleDropdownOpen} data-testid='warehouse-shelving-row-actions-button'>
        <MoreVertOutlined />
      </IconButton>
      <WarehouseShelvingRowDropdownMenu
        anchorEl={anchorElRef.current}
        isOpen={isDropdownOpen}
        onClose={handleDropdownClose}
        onEdit={handleFormDialogOpen}
      />
      {isFormDialogOpen && (
        <WarehouseShelvingFormDialog
          shelving={row.original}
          onSubmit={handleFormDialogSubmit}
          onClose={handleFormDialogClose}
        />
      )}
    </Box>
  )
}

export default WarehouseShelvingRowActions
